import { sum } from 'lodash';
import { Types } from '@fiverr-private/theme';
import type { AvatarProps, AvatarShape, AvatarSizeType, ColorType, SquareRadiuses } from './types';
import {
    AVATAR_SQUARE_RADIUS_BY_SIZE,
    AVATAR_SIZES,
    AVATAR_COLORS,
    AVATAR_COLOR_SCHEME,
    DEFAULT_COLOR,
} from './constants';

export const getAvatarBackgroundColor = ({
    color,
    username,
    isAiAvatar,
}: {
    color: ColorType;
    username: AvatarProps['username'];
    isAiAvatar?: boolean;
}): {
    fontColor?: Types.Color;
    backgroundColor: Types.BackgroundColor;
} => {
    if (isAiAvatar) {
        return {
            backgroundColor: 'purple_200',
        };
    }
    if (username && color === 'auto') {
        const usernameInAscii = sum(username.split('').map((char) => char.charCodeAt(0)));
        const colorIndex = usernameInAscii % AVATAR_COLORS.length;
        return AVATAR_COLOR_SCHEME[AVATAR_COLORS[colorIndex]];
    }

    if (color && color !== 'auto') {
        return AVATAR_COLOR_SCHEME[color];
    }

    return DEFAULT_COLOR;
};

export const getSquareBorderRadius = (size: AvatarSizeType): SquareRadiuses =>
    AVATAR_SQUARE_RADIUS_BY_SIZE[AVATAR_SIZES[size]];

export const getBorderRadius = (shape: AvatarShape, size: AvatarSizeType): Types.BorderRadiuses =>
    shape === 'square' ? getSquareBorderRadius(size) : 'circle';
